class Google {
  constructor(google) {
    if (typeof google === 'undefined') {
      throw new Error('The Google Sign-in API is not initialized!')
    }

    this.google = google
  }

  handleResponse = res => {
    const basicProfile = res.getBasicProfile()
    const authResponse = res.getAuthResponse(true)

    const profile = {
      email: basicProfile.getEmail(),
      first_name: basicProfile.getGivenName(),
      last_name: basicProfile.getFamilyName(),
    }

    return {
      profile,
      ...authResponse,
    }
  }

  isLoggedIn = () => this.google.isSignedIn.get()

  login = () => {
    return new Promise((resolve, reject) => {
      if (this.isLoggedIn()) {
        return resolve(this.handleResponse(this.google.currentUser.get()))
      }

      this.google
        .signIn()
        .then(res => {
          resolve(this.handleResponse(res))
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  logout = async () => {
    if (this.isLoggedIn()) {
      await this.google.signOut()
      await this.google.disconnect()
    }
  }
}

export default Google
